// src/components/Layout/GlobalFooter.jsx
import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { BsInstagram, BsFacebook, BsWhatsapp } from "react-icons/bs";
import { Link } from "react-router-dom";
import logo from "../../../assets/logo/logo.png"; // ajustá el path si hace falta

const GlobalFooter = () => {
  const linkClass =
    "text-light text-opacity-75 text-decoration-none d-block mb-1";

  const handleHoverIn = (e) => {
    e.target.style.opacity = "1";
  };

  const handleHoverOut = (e) => {
    e.target.style.opacity = "0.75";
  };

  return (
    <footer className="bg-dark text-light mt-5 pt-4 pb-3">
      <Container>
        <Row className="gy-4">
          {/* LOGO + TAGLINE */}
          <Col xs={12} md={3}>
            <div className="d-flex align-items-center mb-2">
              <img
                src={logo}
                alt="QRBenefits"
                style={{ height: "32px", marginRight: "8px" }}
              />
              <h5 className="fw-bold mb-0">QRBenefits</h5>
            </div>
            <p className="text-secondary mb-1">
              Descuentos, puntos y beneficios en un solo lugar.
            </p>
            <p className="text-secondary mb-0">
              Made with{" "}
              <span style={{ color: "#ff4f4f", fontSize: "1.2rem" }}>❤️</span>
            </p>
          </Col>

          {/* LINKS PARA USUARIOS */}
          <Col xs={6} md={3}>
            <h6 className="fw-bold">Usuarios</h6>
            <ul className="list-unstyled mb-0">
              <li>
                <Link
                  to="/como-funciona"
                  className={linkClass}
                  style={{ transition: "0.2s" }}
                  onMouseEnter={handleHoverIn}
                  onMouseLeave={handleHoverOut}
                >
                  ¿Cómo funciona?
                </Link>
              </li>
              <li>
                <Link
                  to="/faq"
                  className={linkClass}
                  style={{ transition: "0.2s" }}
                  onMouseEnter={handleHoverIn}
                  onMouseLeave={handleHoverOut}
                >
                  Preguntas frecuentes
                </Link>
              </li>
              {/* <li>
                <Link
                  to="/my-benefits"
                  className={linkClass}
                  style={{ transition: "0.2s" }}
                  onMouseEnter={handleHoverIn}
                  onMouseLeave={handleHoverOut}
                >
                  Mis beneficios
                </Link>
              </li>
              <li>
                <Link
                  to="/my-benefits"
                  className={linkClass}
                  style={{ transition: "0.2s" }}
                  onMouseEnter={handleHoverIn}
                  onMouseLeave={handleHoverOut}
                >
                  Mi perfil
                </Link>
              </li> */}
            </ul>
          </Col>

          {/* LINKS PARA COMERCIOS */}
          <Col xs={6} md={3}>
            <h6 className="fw-bold">Comercios</h6>
            <ul className="list-unstyled mb-0">
              <li>
                <Link
                  to="/sumar-mi-negocio"
                  className={linkClass}
                  style={{ transition: "0.2s" }}
                  onMouseEnter={handleHoverIn}
                  onMouseLeave={handleHoverOut}
                >
                  Sumar mi negocio
                </Link>
              </li>
              <li>
                <Link
                  to="/comercios/informacion"
                  className={linkClass}
                  style={{ transition: "0.2s" }}
                  onMouseEnter={handleHoverIn}
                  onMouseLeave={handleHoverOut}
                >
                  Información para locales
                </Link>
              </li>
              <li>
                <Link
                  to="/planes"
                  className={linkClass}
                  style={{ transition: "0.2s" }}
                  onMouseEnter={handleHoverIn}
                  onMouseLeave={handleHoverOut}
                >
                  Planes disponibles
                </Link>
              </li>
              <li>
                <Link
                  to="/contacto-comercios"
                  className={linkClass}
                  style={{ transition: "0.2s" }}
                  onMouseEnter={handleHoverIn}
                  onMouseLeave={handleHoverOut}
                >
                  Contacto (suma tu comercio a QRBenefits)
                </Link>
              </li>
            </ul>
          </Col>

          {/* INFO & LEGAL - QRBenefits */}
          <Col xs={12} md={3}>
            <h6 className="fw-bold">QRBenefits</h6>
            <ul className="list-unstyled mb-0">
              <li>
                <Link
                  to="/sobre-nosotros"
                  className={linkClass}
                  style={{ transition: "0.2s" }}
                  onMouseEnter={handleHoverIn}
                  onMouseLeave={handleHoverOut}
                >
                  Sobre nosotros
                </Link>
              </li>
              <li>
                <Link
                  to="/legal/privacidad"
                  className={linkClass}
                  style={{ transition: "0.2s" }}
                  onMouseEnter={handleHoverIn}
                  onMouseLeave={handleHoverOut}
                >
                  Política de privacidad
                </Link>
              </li>
              <li>
                <Link
                  to="/legal/terminos"
                  className={linkClass}
                  style={{ transition: "0.2s" }}
                  onMouseEnter={handleHoverIn}
                  onMouseLeave={handleHoverOut}
                >
                  Términos y condiciones
                </Link>
              </li>
              <li>
                <Link
                  to="/legal/cookies"
                  className={linkClass}
                  style={{ transition: "0.2s" }}
                  onMouseEnter={handleHoverIn}
                  onMouseLeave={handleHoverOut}
                >
                  Política de cookies
                </Link>
              </li>
              <li>
                <a
                  href="mailto:soporte@qrbenefits.com"
                  className={linkClass}
                  style={{ transition: "0.2s" }}
                  onMouseEnter={handleHoverIn}
                  onMouseLeave={handleHoverOut}
                >
                  Reportar un problema
                </a>
              </li>
            </ul>
          </Col>
        </Row>

        <hr className="border-secondary mt-4" />

        <Row className="align-items-center text-center text-md-start">
          <Col xs={12} md={6} className="text-secondary">
            © 2025 QRBenefits — Todos los derechos reservados.
          </Col>

          <Col
            xs={12}
            md={6}
            className="d-flex justify-content-center justify-content-md-end gap-3 mt-2 mt-md-0"
          >
            {[BsInstagram, BsFacebook, BsWhatsapp].map((Icon, i) => (
              <a
                key={i}
                href="#!"
                className="text-light text-opacity-75"
                style={{ transition: "0.2s" }}
                onMouseEnter={handleHoverIn}
                onMouseLeave={handleHoverOut}
              >
                <Icon size={20} />
              </a>
            ))}
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default GlobalFooter;
